<template>
    <div class='competitionDetailBox'>
        <CompetitionDetail :form="form"></CompetitionDetail>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="$router.go(-1)" :type="'btnGray'" name="返回" ></Button>
        </div>
    </div>
</template>
<script>
import Button from '@/components/Button.vue'
import CompetitionDetail from '@/components/consultant/CompetitionDetail.vue'
export default {
    name: "competitionDetailBox",
    components: {
        Button,
        CompetitionDetail
    },
    data() {
        return {
            swiperIndex: 0,
            id:this.$route.query.id,
            studentId: sessionStorage.getItem('myStudentStudentId'),
            form: {}
        }
    },
    created() {
        if(this.id) {
          this.detailComplexQualityByParent();
        }else {
            this.form  = JSON.parse(window.sessionStorage.getItem("formCompetition"));
            // console.log(this.form)
        }
    },
    methods: {
      // 获取竞赛详情
        detailComplexQualityByParent(){
        let id = this.$route.query.id;
        console.log(this.ports.parent.student.studentMessage.competition.detailCompetitionInfoByParent)
        this.$ajax.post(this.G_acapi + this.ports.parent.student.studentMessage.competition.detailCompetitionInfoByParent, {
          id:id
        }, {
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then((res) => {
          if (res.data.code == 2000) {
            this.form = res.data.data;
          }
        })
      },
    },
}
</script>
<style scoped lang="less">
.competitionDetailBox {

}
</style>